import { Checkbox } from "components/Form/Checkbox";
import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import FileDetail from "./FileDetail";
import apiCall from "services/apiCall";
import { getSurveyTags } from "services/survey-service";
import useStudentServiceParams from "hooks/useStudentServiceParams";
import { useSurveyContext } from "context/SurveyContext";

function SurveyEnteranceModal({ show, onHide, survey, startSurvey }) {
  const [accepted, setAccepted] = useState(false);
  const [tagList, setTagList] = useState([]);
  const { params } = useStudentServiceParams({
    schoolId: ""
  });
  const { isRequired, canRemindLater } = useSurveyContext();

  useEffect(() => {
    if (show && params.schoolId) {
      getSurveyTagsFromApi();
    }
  }, [show, params.schoolId]);

  const getSurveyTagsFromApi = () => {
    apiCall({
      service: getSurveyTags,
      onSuccess: (res) => {
        if (Array.isArray(res.data)) {
          setTagList(res.data);
        }
      }
    });
  };

  const handleStartSurvey = () => {
    startSurvey(tagList);
  };

  const canCloseModal = !isRequired || (isRequired && canRemindLater);

  return (
    <Modal
      show={show}
      onHide={canCloseModal ? onHide : null}
      backdrop={canCloseModal ? true : "static"}
      keyboard={canCloseModal}
      size="lg"
    >
      <Modal.Header>
        <Modal.Title>
          <FormattedMessage id={"Ankete/Envantere Başlamak Üzeresin"} />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ maxHeight: "60vh", overflowY: "auto" }} className="fc-scroller">
          <FileDetail sha={survey?.descriptionHash} />
        </div>
        {isRequired && !canRemindLater && (
          <div className="alert alert-danger mt-3">
            <strong>Dikkat!</strong> Bu anketi tamamlamanız gerekmektedir. Anketi tamamlamadan
            sistemi kullanmaya devam edemezsiniz.
          </div>
        )}
        <div className="d-flex align-items-center">
          <Checkbox
            isSelected={accepted}
            onChange={() => {
              setAccepted(!accepted);
            }}
          />
          <label className="ml-2 lms-text-elipsis mt-1">Okudum, anladım</label>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div>
          {canCloseModal && (
            <button
              id="dialog-cancel"
              type="button"
              onClick={onHide}
              className="btn btn-light btn-elevate mr-2"
            >
              <FormattedMessage id="DIALOG.CANCEL" />
            </button>
          )}
          <button
            id="dialog-confirmdelete"
            type="button"
            onClick={handleStartSurvey}
            className="btn btn-light-primary"
            disabled={!accepted}
          >
            <FormattedMessage id="Ankete Başla" />
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default SurveyEnteranceModal;
